<template>
  <div class="nebSmallTable">
    <div class="nebSmallTable-row header">
      <div v-for="(column, columnIdx) in columns"
        :key="column"
        class="nebSmallTable-cell"
        :class="{ 'alignRight': columnIdx > 0 }"
      >
        <span>{{ column }}</span>
      </div>
    </div>
    <div v-for="(row, idx) in data"
      :key="idx"
      class="nebSmallTable-row body"
    >
      <div v-for="(key, columnIdx) in Object.keys(row).filter(key => key !== 'color')"
        :key="`${idx}-${key}`"
        class="nebSmallTable-cell"
        :class="{ 'isValue': columnIdx > 0 }"
      >
        <div class="nebSmallTable-color"
          v-if="columnIdx === 0 && row.color"
          :style="{ backgroundColor: row.color }"
        ></div>
        <span>{{ row[key] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NebSmallTable',

  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebSmallTable {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex: 1 1 auto;
  font-family: $defaultFont;
  width: 100%;

  &-color {
    height: 12px;
    width: 12px;
    margin-right: 7px;
  }

  &-row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;

    &.header {
      .nebSmallTable-cell {
        color: $brown-grey;
        font-size: 12px;
        font-weight: 400;
        border-bottom: 1px solid $brown-grey-two;
        padding-bottom: 4px;

        &.alignRight {
          justify-content: flex-end;
        }
      }
    }

    &.body {
      .nebSmallTable-cell {
        color: $slate-grey;
        font-size: 12px;
        font-weight: 300;
        padding-top: 9px;
        padding-bottom: 9px;

        &.isValue {
          font-weight: bold;
          justify-content: flex-end;
        }
      }
    }
  }

  &-cell {
    display: flex;
    flex-flow: row nowrap;
    flex-grow: 1;
    flex-basis: 0;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0px;
    white-space: nowrap;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
